(function () {
  'use strict';

  angular
    .module('relatorios.deviceHealth')
    .config(configDeviceHealth)
    .config(configVehicleHealth);

  function configDeviceHealth($stateProvider) {
    $stateProvider.state('root.device-health', {
      url: '/tempo-real/device-health?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/device-health/device-health.tpl.html',
          controller: 'DeviceHealthCtrl'
        }
      },
      data: {
        titulo: 'ce.tempoReal.deviceHealth.menuLabel',
        roles: [['SAUDE_DO_EQUIPAMENTO']],
        hideTitulo: true
      }
    });
  }

  function configVehicleHealth($stateProvider) {
    $stateProvider.state('root.vehicle-health', {
      url: '/tempo-real/vehicle-health?vfiltro=',
      views: {
        'content@': {
          templateUrl: 'relatorios/device-health/device-health.tpl.html',
          controller: 'DeviceHealthCtrl'
        }
      },
      data: {
        titulo: 'ce.tempoReal.vehicleHealth.menuLabel',
        roles: [['SAUDE_DO_EQUIPAMENTO']],
        hideTitulo: true
      }
    });
  }
}());
